<template>
  <el-dialog
    id="popup_dialog"
    :title="titlu"
    :visible.sync="showPopup"
    class="my-dialog-class custom-width"
    :destroy-on-close="true"

  >
    <el-tooltip placement="bottom-end"  effect="light">
      <div slot="content">Nu se pot face programari din programator pe acest numar de inmatriculare.<br/>Apare mesajul: "Programarea nu a putut fi efectuata. (Programarea dumneavoastra nu poate sa fie inregistrata!)".<br/>Blocarea apare atat pentru agenti cat si pentru clienti.</div>
      <i class="el-icon-info" style="font-size: 17px;color:#409EFF"></i>
    </el-tooltip>

    <div class="container">
      <el-form
        label-position="top"
        :inline="false"
        :rules="rules"
        label-width="100%"
        :model="selectedObject"
        ref="my-form"
        @submit.prevent="save"
        v-loading="loadingVisible"
      >
        <el-row :gutter="15">
          <el-col :md="6">
            <el-form-item label="Numar" prop="NumarMasina">
              <el-input class="full-width" v-model="selectedObject.NumarMasina" :maxlength="12" />
            </el-form-item>
          </el-col>          
          <el-col :md="6">
            <el-form-item label="Observatii" prop="Observatii">
              <el-input class="full-width" v-model="selectedObject.Observatii" />
            </el-form-item>
          </el-col>
         
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false"> Renunta </el-button>
        <el-button type="primary" @click="save"> Salveaza </el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "",
  extends: BasePage,
  data() {
    return {
      baseUrl: "",
      showPopup: false,
      titlu: "",
      mode: "add",
      selectedObject: {
        NumarMasina: "",
        Observatii: "",
      },
      Info: {},
      rules: {
        NumarMasina:               [{ required: true, message: "Campul este obligatoriu" }],
      },
    };
  },
  methods: {
    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.titlu = "Adauga un numar de masina blocata";
        this.selectedObject = { NumarMasina: "",
        Observatii: "",
         };
      } else {
        this.mode = "edit";
        this.titlu = "Editeaza o masina blocata";
        var result = await this.post("blocare_masini/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
      }
    },



    async get_info() {
      var response = await this.post("blocare_masini/get_info_for_dialog");
      this.Info.centre_productie = response.centre_productie;
    },
    async resetObject(){
      // this.selectedObject = { Nume: "" };
    },
    save: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          this.selectedObject.NumarMasina = this.selectedObject.NumarMasina.toUpperCase();
          await this.post("blocare_masini/save", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.$emit("save");
          this.selectedObject = { NumarMasina: "",
                    Observatii: "",
                     };
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less">
#popup_dialog {
  .full-width {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .container {
    width: 100% !important;
  }

  @media only screen and (max-width: 600px) {
    .el-dialog{
      min-width: 90vw !important;
    }
  }
}
</style>